import AxiosClient from './api'
import END_POINT from './constants'

async function getCourseActivityUserList() {
  const axiosClient = new AxiosClient()
  return axiosClient.get(END_POINT.COURSE_ACTIVITY.USER_LIST)
    .then((res) => res.data)
}

async function getStudyCourseTime(payload) {
  const axiosClient = new AxiosClient()
  const q = new URLSearchParams({ ...payload }).toString()
  return axiosClient.get(`${END_POINT.COURSE_ACTIVITY.STUDY_COURSE_TIME}?${q}`)
    .then((res) => res.data)
}

async function getStudyCourseHistory(payload) {
  const axiosClient = new AxiosClient()
  const q = new URLSearchParams({ ...payload }).toString()
  return axiosClient.get(`${END_POINT.COURSE_ACTIVITY.STUDY_COURSE_HISTORY}?${q}`)
    .then((res) => res.data)
}

async function getCourseRankingAll() {
  const axiosClient = new AxiosClient()
  const q = new URLSearchParams({
    courseSearch: '',
    page: 1,
    limit: 5
  }).toString()
  return axiosClient.get(`${END_POINT.COURSE_ACTIVITY.COURSE_RANKING_ALL}?${q}`)
    .then((res) => res.data)
}

async function getCourseRankingNissoken() {
  const axiosClient = new AxiosClient()
  const q = new URLSearchParams({
    courseSearch: '',
    page: 1,
    limit: 5
  }).toString()
  return axiosClient.get(`${END_POINT.COURSE_ACTIVITY.COURSE_RANKING_NISSOKEN}?${q}`)
    .then((res) => res.data)
}

async function getCourseRankingCompany() {
  const axiosClient = new AxiosClient()
  const q = new URLSearchParams({
    courseSearch: '',
    page: 1,
    limit: 5
  }).toString()
  return axiosClient.get(`${END_POINT.COURSE_ACTIVITY.COURSE_RANKING_COMPANY}?${q}`)
    .then((res) => res.data)
}

export {
  getCourseActivityUserList,
  getStudyCourseTime,
  getStudyCourseHistory,
  getCourseRankingAll,
  getCourseRankingNissoken,
  getCourseRankingCompany
}
